import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {loadUserStart} from '../../store/actions/getUser.actions';
import {UserItem} from '../../user.model';
import {Observable} from 'rxjs';
import { State } from '../../store/reducer/landingpage.reducer';
import {ProjektState} from '../../../projektverwaltung/store/reducer/projektverwaltung.reducer';
import {loadDashboardStart} from '../../store/actions/getDashboard.actions';
import {ProjektFormdialogComponent} from '../../../projektverwaltung/components/projekt-form-dialog/projekt-formdialog.component';
import {AddButtonFormdialogComponent} from '../addButton-form-dialog/addButton-formdialog.component';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';
import {checkDashboardStart} from "../../store/actions/dashboard-check.actions";
import {loadRollenStart} from "../../../Mitarbeiterverwaltung/store/actions/rolle.actions";
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';


@Component({
    selector: 'app-landingpage-page',
    templateUrl: './landingpage-page.component.html',
    styleUrls: ['./landingpage-page.component.scss'],
})



export class LandingpagePageComponent implements OnInit{

  public $dashboard;

  /**
   * Constructor of Addresses page
   *
   * @param store - The store service
   * @param dialog - The dialog service
   */
  constructor(private store: Store<{ landingpage: State }>,
              public dialog: MatDialog,
              private breakpointObserver: BreakpointObserver
  ) {
    this.$dashboard = store.pipe(select((state) => state.landingpage.dashboards.items));
  }

    public functionMenuEnabled: boolean;
    public isSmallDevice = false;
    /**
     * Executed when the component is initialized
     */
    public ngOnInit(): void {
      this.store.dispatch(loadRollenStart());
      if ( sessionStorage.getItem('userId') === null){
        return;
      }
      this.store.dispatch(checkDashboardStart());
      this.functionMenuEnabled = true;

      this.breakpointObserver
        .observe(localStorage.getItem('phoneWidth'))
        .pipe(map((result) => result.matches))
        .subscribe((isSmallDevice) => {
          this.isSmallDevice = isSmallDevice;

        });
    }



  public addDashboard(): void {
      if (this.isSmallDevice){
      // tslint:disable-next-line:radix
      const dialogRef = this.dialog.open(AddButtonFormdialogComponent, {
        width: '90%',
        data: {
          title: 'pages.landingpage.addDashboard.title',
          submitButtonLabel: 'pages.landingpage.addDashboard.submitButtonLabel',
          cancelButtonLabel: 'pages.landingpage.addDashboard.cancelButtonLabel',
        },
      });
      dialogRef.afterClosed().subscribe();
      }

  else{
    // tslint:disable-next-line:radix
    const dialogRef = this.dialog.open(AddButtonFormdialogComponent, {
      data: {
        title: 'pages.landingpage.addDashboard.title',
        submitButtonLabel: 'pages.landingpage.addDashboard.submitButtonLabel',
        cancelButtonLabel: 'pages.landingpage.addDashboard.cancelButtonLabel',
      },
    });
    dialogRef.afterClosed().subscribe();
  }
  }
}
